import { camelize } from '../support/index';

var defineMetaGetter = function defineMetaGetter(controller, metaName, suffix) {
  var getterName = suffix ? "".concat(camelize(metaName), "Meta") : camelize(metaName);
  Object.defineProperty(controller, getterName, {
    get: function get() {
      return typeCast(metaValue(metaName));
    }
  });
};

function metaValue(name) {
  var element = document.head.querySelector("meta[name=\"".concat(name, "\"]"));
  return element && element.getAttribute('content');
}

function typeCast(value) {
  try {
    return JSON.parse(value);
  } catch (o_O) {
    return value;
  }
}

export var useMeta = function useMeta(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    suffix: true
  };
  var metaNames = controller.constructor.metaNames;
  var suffix = options.suffix; // defines the individual meta getters

  metaNames === null || metaNames === void 0 ? void 0 : metaNames.forEach(function (metaName) {
    defineMetaGetter(controller, metaName, suffix);
  }); // define the metas getter to retreive an object with all metas

  Object.defineProperty(controller, 'metas', {
    get: function get() {
      var result = {};
      metaNames === null || metaNames === void 0 ? void 0 : metaNames.forEach(function (metaName) {
        var value = typeCast(metaValue(metaName));

        if (value !== undefined && value !== null) {
          result[camelize(metaName)] = value;
        }
      });
      return result;
    }
  });
};